import { useEffect } from 'react';
import * as Tone from "tone";

export type UseStartAudioContextProps = {
  callback?: () => void
}

export function useStartAudioContext(props:UseStartAudioContextProps) {
  useEffect(() => {
    const startAudioContext = async () => {
      document.querySelector("body")?.removeEventListener("click", startAudioContext);
      Tone.start().then((typeof props.callback === "function" ? props.callback : () => {}));
    };
    document.querySelector("body")?.addEventListener("click", startAudioContext);
    return () => {
      document.querySelector("body")?.removeEventListener("click", startAudioContext);
    };
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
}
